import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Instance } from '../interfaces/instance.interface';
import { InstanceSelector } from '../interfaces/instanceSelector.interface';
import { NgxSpinnerService } from 'ngx-spinner';
import { ErrorModalService } from '../modal/error.modal.service';
import { AuthService } from '../auth/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SessionService } from '../session/session.service';
import { fadeInAnimation } from '../_animations/fade-in.animation';

@Component({
    selector: 'app-instances',
    templateUrl: './instance.component.html',
    animations: [fadeInAnimation],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InstanceComponent {
  constructor(
    protected auth: AuthService,
    protected sessionService: SessionService,
    protected spinner: NgxSpinnerService,
    protected errorModalService: ErrorModalService,
    protected route: ActivatedRoute,
    protected router: Router) {
    this.loadInstances();
  }

  public get isLoaded() { return !!this.instances };

  public lastInstanceId: string;
  public lastRoleType: string;

  public instances: Instance[];

  private loadInstances() {
    this.spinner.show();
    this.sessionService.getInstances().subscribe(
      (instanceSelector: InstanceSelector) => {
        if (!instanceSelector || !instanceSelector.instances || !instanceSelector.instances.length) {
          this.spinner.hide();
          this.errorModalService.open('Inloggningsfel', 'Det finns inga uppgifter om dig här.', () => {
            this.router.navigate(['/home']);
            this.auth.logout();
          });
          return;
        } else if (instanceSelector.instances.length === 1) {
          if (instanceSelector.instances[0].id === 'HasRequests')
            this.router.navigate(['/mina-meddelanden']);

          this.setInstance(instanceSelector.instances[0]); // bara en instans, använd den.
          return;
        } else if (instanceSelector.lastLogin) {
          let lastInstance: Instance;
          if (lastInstance = instanceSelector.instances.find(i =>
            i.id === instanceSelector.lastLogin.instanceId &&
            i.roleType === instanceSelector.lastLogin.roleType)) {
            this.lastInstanceId = lastInstance.id;
            this.lastRoleType = lastInstance.roleType;
            lastInstance.defaultUrl = instanceSelector.lastLogin.url || lastInstance.defaultUrl;
            this.route.queryParams.subscribe(queryParams => {
              if (!JSON.parse(queryParams['enforce'])) {
                this.setInstance(lastInstance);
                return;
              }
            });
          }
        }

        this.spinner.hide();
        this.instances = instanceSelector.instances;
        this.instances = this.sortInstances(instanceSelector.instances);
      },
      (error) => {
        this.spinner.hide();
        this.errorModalService.open('Inloggningsfel', error.error.exceptionMessage, () => {
          this.router.navigate(['/home']);
          this.auth.logout(false);
        });
      });
  }

  public setInstance(instance: Instance) {
    this.sessionService.setInstance(instance, instance.defaultUrl);
  }

  private sortInstances(instances: Instance[]): Instance[] {
    return instances.sort((a, b) => {
      const dateA = a.decisionDate ? new Date(a.decisionDate).getTime() : 0;
      const dateB = b.decisionDate ? new Date(b.decisionDate).getTime() : 0;

      if (dateB !== dateA) {
        return dateB - dateA; // Sortera på decisionDate (nyast först)
      }

      const roleComparison = a.roleName.localeCompare(b.roleName);
      if (roleComparison !== 0) {
        return roleComparison; // Sortera på roleName om decisionDate är lika
      }

      return a.name.localeCompare(b.name); // Sortera på name om roleName också är lika
    });
  }
}
